export enum AddressFormKey {
  ADDRESS_ID = 'externalAVSAddressId',
  ADDRESS = 'address',
  ADDRESS_LINE_1 = 'addressLine1',
  SUB_BUILDING = 'subBuilding',
  STREET_NUMBER = 'streetNumber',
  STREET = 'street',
  PO_BOX = 'poBox',
  CITY = 'city',
  STATE_CODE = 'regionOrStateCode',
  POSTAL_CODE = 'postalCode',
  IS_VALID = 'isValid',
  MERCHANDISE_ADDRESS_ID = 'merchandiseLocationExternalAVSAddressId',
  MERCHANDISE_ADDRESS = 'merchandiseLocationAddress',
  MERCHANDISE_ADDRESS_LINE_1 = 'merchandiseLocationLine1',
  MERCHANDISE_SUB_BUILDING = 'merchandiseLocationSubBuilding',
  MERCHANDISE_STREET_NUMBER = 'merchandiseLocationStreetNumber',
  MERCHANDISE_STREET = 'merchandiseLocationStreet',
  MERCHANDISE_PO_BOX = 'merchandiseLocationPoBox',
  MERCHANDISE_CITY = 'merchandiseLocationCity',
  MERCHANDISE_STATE_CODE = 'merchandiseLocationRegionOrStateCode',
  MERCHANDISE_POSTAL_CODE = 'merchandiseLocationPostalCode',
  MERCHANDISE_IS_VALID = 'merchandiseLocationIsValid',
}
